// smootherContext.js
import { createContext, useContext } from 'react'

export const SmootherContext = createContext(null)

export const useSmoother = () => useContext(SmootherContext)
